import React from 'react';
import { TrendingDown, Zap, Activity, MapPin, Users, DollarSign } from 'lucide-react';
import { benefits } from '../mock';

const iconMap = {
  TrendingDown: TrendingDown,
  Zap: Zap,
  Activity: Activity,
  MapPin: MapPin,
  Users: Users,
  DollarSign: DollarSign,
};

const BenefitsSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Benefits & ROI
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Transform your returnable packaging operations
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon];
            return (
              <div 
                key={index} 
                className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 group hover:border-red-200"
              >
                <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-blue-900 to-blue-700 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
              </div>
            );
          })}
        </div>

        {/* ROI Image */}
        <div className="mt-16 max-w-4xl mx-auto">
          <img 
            src="https://images.unsplash.com/photo-1740914994657-f1cdffdc418e"
            alt="Warehouse operations ROI"
            className="rounded-2xl shadow-2xl w-full h-64 object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
